var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import VueGtag from 'vue-gtag';
import { BRow, BCol, BButton, BFormGroup, BFormInput, BFormCheckbox, BOverlay, BAlert, BCard } from 'bootstrap-vue';
import round from 'lodash/round';
import axios from 'axios';
import debounce from 'lodash/debounce';
import { addToCart } from 'ts/modules/cart';
import { checkMountStock } from 'ts/modules/stock';
import { getVatMode, isAdmin } from 'ts/modules/helpers';
import UnitSelector from 'components/UnitSelector.vue';
import SizeInput from 'components/SizeInput.vue';
import MountboardColours from 'components/MountboardColours.vue';
import DiscountsBreakdown from 'components/DiscountsBreakdown.vue';
import UndermountSelector from 'components/materials/UndermountSelector.vue';
import MountOrderBreakdown from 'components/materials/MountOrderBreakdown.vue';
import MountVisualisation from 'components/materials/MountVisualisation.vue';
Vue.use(VueGtag, {
    config: { id: "UA-939335-4" }
});
const urlParams = new URLSearchParams(window.location.search);
let StandardCTS = class StandardCTS extends Vue {
    constructor() {
        super(...arguments);
        this.quantity = 1;
        this.loading = true;
        this.addingToCart = false;
        this.selectedBoard = null;
        this.vatMode = 'inc';
        this.isAdmin = false;
        this.includeUndermount = urlParams.get('incUndermount') == '1' ? true : false;
        this.inStock = true;
        this.externalSize = {
            length: parseInt(urlParams.get('extLengthMM') || '254'),
            width: parseInt(urlParams.get('extWidthMM') || '203'),
        };
        this.apertureSize = {
            length: parseInt(urlParams.get('apLengthMM') || '197'),
            width: parseInt(urlParams.get('apWidthMM') || '146'),
        };
        this.displayUnit = urlParams.get('displayUnit') || 'mm';
        this.mountPricing = {
            base_unit_price: '0.00',
            ex_vat_base_unit_price: '0.00',
            unit_price: '0.00',
            total_price: '0.00',
            unit_discount: '0.00',
            total_discount: '0.00'
        };
        this.withUndermountPricing = {
            base_unit_price: '0.00',
            unit_price: '0.00',
            ex_vat_base_unit_price: '0.00',
            total_price: '0.00',
            unit_discount: '0.00',
            total_discount: '0.00'
        };
        this.debouncedCheckStock = debounce(this.checkStock, 250);
        this.debouncedPrice = debounce(this.updatePricing, 250);
        this.validationStrings = [];
    }
    get isAddToCartDisabled() {
        if (this.addingToCart)
            return true;
        return (this.validationStrings.length > 0 || this.loading) && !this.isAdmin;
    }
    get borderSizes() {
        return {
            width: round((this.externalSize.width - this.apertureSize.width) / 2, 1),
            length: round((this.externalSize.length - this.apertureSize.length) / 2, 1)
        };
    }
    get borderExternalProportions() {
        return {
            width: this.borderSizes.width / this.externalSize.width,
            length: this.borderSizes.length / this.externalSize.length
        };
    }
    get bespokeUrl() {
        let params = new URLSearchParams({
            extLengthMM: String(this.externalSize.length),
            extWidthMM: String(this.externalSize.width),
            apLengthMM: String(this.apertureSize.length),
            apWidthMM: String(this.apertureSize.width),
            incUndermount: String(this.includeUndermount ? 1 : 0)
        });
        return '/cut-to-size-picture-mounts/bespoke?' + params.toString();
    }
    pricingPayload(sku, hasUndermount = false) {
        return {
            params: {
                sku,
                length: this.externalSize.length,
                width: this.externalSize.width,
                quantity: this.quantity || 1,
                withSheets: hasUndermount ? 'B-61' : undefined
            }
        };
    }
    onParametersChanged() {
        this.debouncedPrice();
        this.debouncedCheckStock();
    }
    onSelectedBoardChanged() {
        this.updatePricing();
        this.checkStock();
    }
    checkStock() {
        return __awaiter(this, void 0, void 0, function* () {
            this.inStock = yield checkMountStock('MCTS-' + (this.selectedBoard ? this.selectedBoard.stock_lookup_sku : '8001'), this.externalSize, this.quantity || 1);
        });
    }
    updatePricing() {
        this.loading = true;
        let umPricing = axios
            .get('/api/pricing/mountboard/cutToSize', this.pricingPayload('MCTS-' + (this.selectedBoard ? this.selectedBoard.stock_lookup_sku : '8001'), true))
            .then(({ data }) => this.withUndermountPricing = data);
        let mountPricing = axios
            .get('/api/pricing/mountboard/cutToSize', this.pricingPayload('MCTS-' + (this.selectedBoard ? this.selectedBoard.stock_lookup_sku : '8001')))
            .then(({ data }) => this.mountPricing = data);
        Promise
            .all([umPricing, mountPricing])
            .then(() => this.loading = false);
    }
    get exVatUnitPrice() {
        return this.includeUndermount ? this.withUndermountPricing.ex_vat_base_unit_price : this.mountPricing.ex_vat_base_unit_price;
    }
    get unitPrice() {
        return this.includeUndermount ? this.withUndermountPricing.base_unit_price : this.mountPricing.base_unit_price;
    }
    get itemPrice() {
        return this.includeUndermount ? this.withUndermountPricing.unit_price : this.mountPricing.unit_price;
    }
    get totalPrice() {
        return this.includeUndermount ? this.withUndermountPricing.total_price : this.mountPricing.total_price;
    }
    get calcUndermountPrice() {
        return (parseFloat(this.withUndermountPricing.unit_price.replace(/,/g, '')) - parseFloat(this.mountPricing.unit_price.replace(/,/g, ''))).toFixed(2);
    }
    addToCart() {
        this.addingToCart = true;
        const item = {
            sku: `MCTS-${this.selectedBoard ? this.selectedBoard.stock_lookup_sku : '8001'}`,
            qty: this.quantity,
            attributes: {
                "External Size": `${this.externalSize.length}x${this.externalSize.width}mm`,
                "Aperture Size": `${this.apertureSize.length}x${this.apertureSize.width}mm`,
                "Undermount": this.includeUndermount ? `Yes` : `No`
            }
        };
        // Log the add to cart event
        this.$gtag.event('add_to_cart', {
            "items": [
                {
                    "id": item.sku,
                    "name": `${item.sku} - Standard Size Mount`,
                    "brand": "Brampton Framing",
                    "category": "Mountboard Cut to Size",
                    "quantity": this.quantity,
                    "price": this.exVatUnitPrice
                }
            ]
        });
        addToCart(item, false)
            .finally(() => this.addingToCart = false);
    }
    get validate() {
        let validations = {
            external: null,
            aperture: null,
            borders: null
        };
        this.validationStrings = [];
        if ((this.externalSize.width < this.apertureSize.width) ||
            (this.externalSize.length < this.apertureSize.length)) {
            this.validationStrings.push('Your aperture is larger than your external size on one or both dimensions.');
            validations.external = false;
            validations.aperture = false;
        }
        if (this.borderSizes.width < 10 || this.borderSizes.length < 10) {
            this.validationStrings.push('We have a minimum border width of 10mm to ensure that the mount can be cut correctly.');
            validations.borders = false;
        }
        if (this.borderExternalProportions.width < 0.03) {
            this.validationStrings.push("The left or right borders are too narrow to safely cut at the size you have entered.  Please try a wider border.");
            validations.borders = false;
        }
        if (this.borderExternalProportions.length < 0.03) {
            this.validationStrings.push("The top or bottom borders are too narrow to safely cut at the size you have entered.  Please try a wider border.");
            validations.borders = false;
        }
        if (!this.inStock) {
            this.validationStrings.push("Unfortunately there is not enough stock of your chosen mountboard colour to fulfill your order.");
        }
        if (this.quantity >= 500) {
            this.validationStrings.push("To order over 500 mounts, please email us with your requirements.  We are happy to supply large quantities but we may need to alter our estimated lead times depending on size/colour/overall quantity.");
        }
        return validations;
    }
    created() {
        // Get external and aperture size from url
        let locationBits = window.location.pathname.split('/');
        let externalStd;
        let apertureStd;
        if (locationBits[2] == 'to-fit-item') {
            externalStd = locationBits[5];
            apertureStd = locationBits[3];
        }
        else {
            externalStd = locationBits[3];
            apertureStd = locationBits[5];
        }
        axios
            .get('/api/sizes/byUrlName', { params: { name: externalStd } })
            .then(({ data }) => {
            this.externalSize.width = data.size.width;
            this.externalSize.length = data.size.length;
        })
            .then(() => axios
            .get('/api/sizes/byUrlName', { params: { name: apertureStd } })
            .then(({ data }) => {
            if (this.externalSize.width > this.externalSize.length) {
                this.apertureSize.width = Math.max(data.size.width, data.size.length) - 6;
                this.apertureSize.length = Math.min(data.size.width, data.size.length) - 6;
            }
            else {
                this.apertureSize.width = Math.min(data.size.width, data.size.length) - 6;
                this.apertureSize.length = Math.max(data.size.width, data.size.length) - 6;
            }
        }))
            .then(() => this.loading = false)
            .finally(() => this.updatePricing);
        isAdmin()
            .then(isAdmin => this.isAdmin = isAdmin);
        this.vatMode = getVatMode();
    }
};
__decorate([
    Watch('quantity')
], StandardCTS.prototype, "onParametersChanged", null);
__decorate([
    Watch('selectedBoard')
], StandardCTS.prototype, "onSelectedBoardChanged", null);
StandardCTS = __decorate([
    Component({
        components: {
            BRow, BCol, BButton, BFormGroup, BFormInput, BFormCheckbox, BOverlay, BAlert, BCard,
            UnitSelector, SizeInput, MountboardColours, DiscountsBreakdown, UndermountSelector, MountOrderBreakdown, MountVisualisation
        }
    })
], StandardCTS);
export default StandardCTS;
